import FontFaceObserver from 'fontfaceobserver';

const map = new Map();

/**
 *
 * @param {string} fontName
 * @return {Promise}
 */
export function loadFont(fontName) {
  if (!map.has(fontName)) {
    map.set(fontName, new FontFaceObserver(fontName).load(null, 5000));
  }

  return map.get(fontName);
}
